import React, { useState } from "react";
import Login from "../../Auth/Login";
import CustomModal from "../CustomModal";

const LoginModal = ({ show, onClose = null }) => {
  const [modalTitle, setModalTitle] = useState("Login");
  return (
    <CustomModal
      show={show}
      title={""}
      className="auth-modal-wrapper"
      onClose={onClose}
    >
      <Login
        asModal={true}
        redirect={false}
        onSuccess={() => onClose()}
        updateTitle={setModalTitle}
        onClose={() => onClose()}
      />
    </CustomModal>
  );
};

export default LoginModal;
